export default [
    {
        "id": "0",
        "path": "localBgImages/1.jpg",
    },
    {
        "id": "1",
        "path": "localBgImages/2.jpg",
    },
    {
        "id": "2",
        "path": "localBgImages/3.jpg",
    },
    {
        "id": "3",
        "path": "localBgImages/4.jpg",
    },
    {
        "id": "4",
        "path": "localBgImages/5.jpg",
    },
    {
        "id": "5",
        "path": "localBgImages/6.jpg",
    },
    {
        "id": "6",
        "path": "localBgImages/7.jpg",
    },
    {
        "id": "7",
        "path": "localBgImages/8.jpg",
    },
    {
        "id": "8",
        "path": "localBgImages/9.jpg",
    },
    {
        "id": "9",
        "path": "localBgImages/10.jpg",
    },
    {
        "id": "10",
        "path": "localBgImages/11.jpg",
    },
    {
        "id": "11",
        "path": "localBgImages/12.jpg",
    }
]